module.exports = __webpack_public_path__ + "img/img02.844af690.svg";